import { Alert, Container, Loading } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

const ProcessingMatches: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container width={"100%"}>
      <Alert iconEnabled={false} variant={"info"}>
        <Container display={"flex"} gap={1}>
          <Loading color={"blue"} size={"sm"} />
          {t("group.matches.matchesTable.processing")}
        </Container>
      </Alert>
    </Container>
  );
};

export { ProcessingMatches };
